export default __webpack_public_path__ + "static/media/resources-for-you-illustration.d6416e26.png";